import React from 'react';

const Loading = () => {
  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes rotateAndScale {
            0% {
              transform: rotate(0deg) scale(1);
            }
            25% {
              transform: rotate(90deg) scale(1.2);
            }
            50% {
              transform: rotate(180deg) scale(1);
            }
            75% {
              transform: rotate(270deg) scale(0.8);
            }
            100% {
              transform: rotate(360deg) scale(1);
            }
          }
          .loading-symbol {
            width: 100px; /* Adjust size as needed */
            height: 100px; /* Adjust size as needed */
            animation: rotateAndScale 2s linear infinite;
            filter: contrast(100%) grayscale(100%);
          }
        `}
      </style>
      <img src="/batman.png" alt="Loading" className="loading-symbol" />
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#fff', // Change color if needed
  },
};

export default Loading;
